document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[nss-article-recipe]:not(.loaded)').forEach(articleRecipe => {
        articleRecipe.classList.add('loaded');
        const articleVideos = articleRecipe.querySelectorAll('video');
        articleVideos.forEach(articleVideo => {
            if (!articleVideo.controls) {
                const videoWrap = articleVideo.parentNode;
                if (!videoWrap.classList.contains('video-wrapper')) {
                    const newWrapper = document.createElement('div');
                    newWrapper.classList.add('video-wrapper');
                    const newButton = document.createElement('button');
                    newButton.type = "button";
                    newButton.classList.add('video-trigger-button');
                    newButton.setAttribute('nss-trigger-video', '');
                    newButton.innerHTML = '<span class="sr-only">Play Video</span>';
                    videoWrap.parentNode.insertBefore(newWrapper, videoWrap);
                    newWrapper.appendChild(articleVideo);
                    newWrapper.appendChild(newButton);
                    videoWrap.remove();
                }
            }
        });

        const articleVideoTriggers = articleRecipe.querySelectorAll('[nss-trigger-video]');
        articleVideoTriggers.forEach(articleVideoTrigger => {
            articleVideoTrigger.addEventListener('click', () => {
                const videoWrap = articleVideoTrigger.parentNode;
                const videoEl = videoWrap.querySelector('video');
                if (videoEl) {
                    videoEl.controls = true;
                    videoEl.play();
                    videoWrap.classList.add('video--played');
                }
            });
        });
    });
});